module.exports = __webpack_public_path__ + "static/media/prototype.e6704fb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/ProgramTimeline/img/prototype.svg
// module id = 235
// module chunks = 0